import { SuperEllipse } from '@xing-com/super-ellipse';

import * as Styled from './super-ellipse-with-top-badge.styled';

type SuperEllipseWithTopBadgeProps = {
  count: number;
};

export const SuperEllipseWithTopBadge: React.FC<
  SuperEllipseWithTopBadgeProps
> = ({ count }) => {
  return (
    <Styled.SuperEllipseWrapper>
      <SuperEllipse type="avatar" size="xxsmall" />
      {count ? (
        <Styled.NotificationBadgeWithCount>
          {count}
        </Styled.NotificationBadgeWithCount>
      ) : null}
    </Styled.SuperEllipseWrapper>
  );
};
